import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  // Save Draft Segments
  draftSaveRequest: ['scriptId', 'audioUrl', 'segments', 'options', 'callback'],
  draftSaveSuccess: ['data'],
  draftSaveFailure: ['error'],

  // Get Draft Segments
  draftGetRequest: ['scriptId', 'callback'],
  draftGetSuccess: ['data'],
  draftGetFailure: ['error'],

  // Delete Draft Segments
  draftDeleteRequest: ['scriptId', 'callback'],
  draftDeleteSuccess: [],
  draftDeleteFailure: ['error'],

  // Set current draft
  setCurrentDraft: ['draft'],
  clearCurrentDraft: [],

  // Reset
  draftReset: [],
})

export const DraftTypes = Types
export default Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  // Save
  saveFetching: false,
  saveError: null,

  // Get
  data: null,
  fetching: false,
  error: null,

  // Delete
  deleteFetching: false,
  deleteError: null,

  // Current draft
  currentDraft: null,
}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Save
    case Types.DRAFT_SAVE_REQUEST:
      return { ...state, saveFetching: true, saveError: null }
    case Types.DRAFT_SAVE_SUCCESS:
      return { ...state, saveFetching: false, saveError: null, data: action.data }
    case Types.DRAFT_SAVE_FAILURE:
      return { ...state, saveFetching: false, saveError: action.error }

    // Get
    case Types.DRAFT_GET_REQUEST:
      return { ...state, fetching: true, error: null }
    case Types.DRAFT_GET_SUCCESS:
      return { ...state, data: action.data, fetching: false, error: null }
    case Types.DRAFT_GET_FAILURE:
      return { ...state, fetching: false, error: action.error }

    // Delete
    case Types.DRAFT_DELETE_REQUEST:
      return { ...state, deleteFetching: true, deleteError: null }
    case Types.DRAFT_DELETE_SUCCESS:
      return { ...state, deleteFetching: false, deleteError: null, data: null }
    case Types.DRAFT_DELETE_FAILURE:
      return { ...state, deleteFetching: false, deleteError: action.error }

    // Current Draft
    case Types.SET_CURRENT_DRAFT:
      return { ...state, currentDraft: action.draft }
    case Types.CLEAR_CURRENT_DRAFT:
      return { ...state, currentDraft: null }

    // Reset
    case Types.DRAFT_RESET:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
